// UserContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import jwtAxios from '@projectK/services/auth/JWT';
import PropsTypes from 'prop-types';

// Create a Context
const GeneralContext = createContext();

// Create a Provider component
export const CheckAdddonsContextProvider = ({ children }) => {
  const [CheckAdddonsSettings, setCheckAdddonsSettings] = useState([]);//NOSONAR
  const [loading, setLoading] = useState(true);

  const fetchcompanyData = async () => {
    try {
      const response = await jwtAxios.get(`/public/app-settings`);
      const { data } = response;
      const addOns =
        Object.keys(data?.addOns)?.length === 0 ? [] : data?.addOns;
      setCheckAdddonsSettings(addOns);
    } catch (error) {
      console.error('Error fetching appearance settings:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchcompanyData();
  }, []);

  return (
    <GeneralContext.Provider value={{//NOSONAR
      CheckAdddonsSettings, loading
      }}>
      {children}
    </GeneralContext.Provider>
  );
};
CheckAdddonsContextProvider.propTypes = {
  children: PropsTypes.any,
};

// Create a custom hook to use the context
export const useAddonsSettings = () => useContext(GeneralContext);
